import React, { useEffect, useState } from 'react';
import { StyleProp, TextStyle } from 'react-native';
import ExternalSelect from '../../../ExternalSelect';
import { translate } from '../../../../services/translate';
import { cameraService } from '../../../../services/central-api/cameras';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}


export default function DownloadTagsDropdown({ value, setValue, zIndex, labelStyle, viewStyle }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getTags() {
        try {
            const tags = await cameraService.getSimplifiedDownloadTags();

            setItems(tags.map((tag) => {
                return {
                    value: tag.id,
                    label: tag.name,
                    color: tag.color,
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getTags();
    }, []);

    return (
        <ExternalSelect
            label={translate('tags')}
            selectedLabel={translate('selectedTags')}
            items={items}
            setValue={setValue}
            value={value}
            multiple={true}
            zIndex={zIndex}
            onRemove={(items) => setValue(items as number[])}
            initialSelectedItems={items.filter(item => value.includes(item.value))}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}
